import axiosInstance from "../axiosInstance";
import { UserRole } from "types/users";


export interface JoinUser {
  firstName: string;
  lastName: string;
  password: string;
}
export interface AcceptInvitePayload {
  user_key: string;
  payload: JoinUser;
}
export interface UserResponse{
  appUserUuid: string;
email:string; 
firstName:string;
isOrgOnboarded:boolean;
isUserJoined:boolean;
lastName:string;
orgUuid:string;
roleList:UserRole[];
status:true;
message?:string;
isUserActive?:boolean;
}
export interface JoinUserResponse {
 response:UserResponse;
}

export const joinUser = async (
  { user_key, payload }: AcceptInvitePayload
): Promise<JoinUserResponse> => {

  const { data } = await axiosInstance.post(
    `/onboarding/join/${user_key}/native`,
    payload
  );

  if (!data?.response?.status) {
    throw new Error(
      data?.response?.message || "Failed to create account."
    );
  }

  return data.response;
};

